import { HttpMethods } from "../configUtils";
import {
    formatHTTPGetUrl,
    getPreUrlByApiTag,
} from "./replaceUrlBydiffrentFetch";

/**
 *
 * java接口相关的http请求封装
 *
 * url：路径
 * params：参数
 *
 */
enum ErrorCode {
    Success = 200,
}

async function handleErrors(response: Response): Promise<any> {
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
    }
    const responseData = await response.json();
    const code = responseData.code;
    if (code === 500) {
        throw new Error(responseData.msg);
    }
    switch (code) {
        case "succes":
            // 存在请求成功后无data的情况，只有请求成功的状态
            return responseData.data ?? responseData;
        case ErrorCode.Success:
            return responseData.products;
        // 空数据
        case "error_data_empty":
        case 204:
            return responseData;
        // 各种请求问题
        default:
            console.log(response.url);
            throw new Error(responseData.msg);
    }
}

class HandleJavaUsualFetch {
    static async request(
        url: string,
        method: HttpMethods,
        params: { [key: string]: any } = {},
        options: RequestInit = {},
    ): Promise<any> {
        let req_url: any = getPreUrlByApiTag(url, "api/javaUsual/");

        options.method = method;
        options.headers = {
            "Content-Type": "application/json",
            ...options.headers,
        };

        if (method === HttpMethods.GET) {
            req_url = formatHTTPGetUrl(req_url, params);
        } else {
            options.body = JSON.stringify(params);
        }
        try {
            const response = await fetch(req_url, options);
            return handleErrors(response);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }

    static async get(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaUsualFetch.request(
            url,
            HttpMethods.GET,
            params,
            options,
        );
    }

    static async post(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaUsualFetch.request(
            url,
            HttpMethods.POST,
            params,
            options,
        );
    }

    static async patch(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaUsualFetch.request(
            url,
            HttpMethods.PATCH,
            params,
            options,
        );
    }

    static async put(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaUsualFetch.request(
            url,
            HttpMethods.PUT,
            params,
            options,
        );
    }

    static async delete(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaUsualFetch.request(
            url,
            HttpMethods.DELETE,
            params,
            options,
        );
    }
}

export default HandleJavaUsualFetch;
